

export class Constant {
   

    
    
 
   

 
    //Initialization
    static config: any = {};
    static uri = {
        amlReviewURI: '',
        advisorHierarchy:'',
        getEmployeeTree: '',
         getemployeeCertificationDetails:'',
        sendBulkEmail: '',

        
    };

    static routes = {
        home: 'amlhome',
       
    };

    static updateConfig = ((configvalues: any) => {

        Constant.config.clientId = configvalues.clientid;
        Constant.config.instance = configvalues.instance;
        Constant.config.tenant = configvalues.tenant;
        Constant.config.appInsightKey = configvalues.appinsightkey;
        Constant.config.scope = configvalues.scope;
        Constant.config.scopes = (configvalues.scope || '')
            .split(',')
            .map((s: string) => s.trim())
            .filter((s: string) => !!s);
        Constant.config.autority = configvalues.instance + configvalues.tenant;
        Constant.config.superUsers = configvalues.superusers ? (<string>configvalues.superusers).toLocaleUpperCase().split(',') : [];
        Constant.config.pptUrl = configvalues.ppturl;
        Constant.config.compusers = configvalues.compusers ? (<string>configvalues.compusers).toLocaleUpperCase().split(',') : [];
        Constant.config.nfsreportenable = configvalues.nfsreportenable ? configvalues.nfsreportenable : "N";
        Constant.config.env = configvalues.env;

        Constant.config.latestMonth = configvalues.latestmonth;
        Constant.config.latestYr = configvalues.latestyr;

        Constant.config.apiBaseUrl = configvalues.apibaseurl;
        Constant.config.apiEnvUrl = configvalues.apienvurl;
        Constant.uri.amlReviewURI = configvalues.apibaseurl + 'aml/client-reviews';
        Constant.uri.advisorHierarchy = `${Constant.config.apiBaseUrl}Advisors/AdvisorHirerarchy`;
        Constant.uri.getEmployeeTree = `${Constant.config.apiBaseUrl}compliance/employee-tree`;
        Constant.uri.getemployeeCertificationDetails = `${Constant.config.apiBaseUrl}compliance/employee-certification-details`;
        Constant.uri.sendBulkEmail = `${Constant.config.apiBaseUrl}notification/bulk_email_send`;

        });


}
